//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import ProcessSelector from "@/components/ProcessSelector";
import ProcessInfo from "@/components/ProcessInfo";

export default {
  name: 'Home',
  components: {
    ProcessSelector,
    ProcessInfo
  }
}
